"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APFilterDate = void 0;
var moment_1 = __importDefault(require("@date-io/moment"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var SwapVertRounded_1 = __importDefault(require("@material-ui/icons/SwapVertRounded"));
var pickers_1 = require("@material-ui/pickers");
var moment_2 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
var DialogHelper_1 = require("../../dialogs/DialogHelper");
var showErrorDialog_1 = require("../../dialogs/showErrorDialog");
var Common_1 = require("../../layout/Common");
var APDialogCard_1 = require("../../elements/APDialogCard");
var APText_1 = require("../../elements/APText");
var APFlex_1 = require("../../layout/APFlex");
var APFilterMenu_1 = require("./APFilterMenu");
function showDatePickerDialog(_a) {
    var label = _a.label, initial = _a.initial, clearable = _a.clearable;
    return __awaiter(this, void 0, void 0, function () {
        var current;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    current = initial;
                    return [4 /*yield*/, DialogHelper_1.launchDialog(function (deferred) {
                            return react_1.default.createElement(pickers_1.MuiPickersUtilsProvider, { utils: moment_1.default },
                                react_1.default.createElement(APDialogCard_1.APDialogCard, { title: label !== null && label !== void 0 ? label : "Select Date", style: { minWidth: 0 } },
                                    react_1.default.createElement(APFlex_1.APColumn, { crossAxisAlignment: 'stretch' },
                                        react_1.default.createElement(pickers_1.DatePicker, { color: 'secondary', variant: "static", open: true, value: current, onChange: function (v) {
                                                if (v)
                                                    current = v.format("YYYY-MM-DD");
                                            } }),
                                        react_1.default.createElement(Common_1.APSizedBox, { height: "16px" }),
                                        react_1.default.createElement(APFlex_1.APRow, { mainAxisSize: 'max', mainAxisAlignment: 'spaceBetween', style: { padding: "4px" } },
                                            clearable
                                                &&
                                                    react_1.default.createElement(Button_1.default, { variant: 'text', color: 'primary', onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                                            return __generator(this, function (_a) {
                                                                deferred.resolve(undefined);
                                                                return [2 /*return*/];
                                                            });
                                                        }); } }, "CLEAR"),
                                            react_1.default.createElement(Button_1.default, { variant: 'contained', color: 'primary', onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                                    return __generator(this, function (_a) {
                                                        deferred.resolve(current);
                                                        return [2 /*return*/];
                                                    });
                                                }); } }, "SET")))));
                        })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
function APFilterDate(_a) {
    var _this = this;
    var header = _a.header, onChange = _a.onChange, initialValue = _a.initialValue, clearable = _a.clearable;
    var _b = react_1.useState(initialValue !== null && initialValue !== void 0 ? initialValue : {}), selected = _b[0], setSelected = _b[1];
    react_1.useEffect(function () {
        onChange(selected);
    }, [selected]);
    react_1.useEffect(function () {
        if (initialValue)
            setSelected(initialValue);
    }, [initialValue === null || initialValue === void 0 ? void 0 : initialValue.from, initialValue === null || initialValue === void 0 ? void 0 : initialValue.to]);
    return react_1.default.createElement(APFlex_1.APColumn, { mainAxisSize: 'min', crossAxisAlignment: 'stretch' },
        react_1.default.createElement(APFilterMenu_1.HeaderItem, { text: header }),
        react_1.default.createElement(Common_1.APPadding, { padding: "12px 12px 8px" },
            react_1.default.createElement(APFlex_1.APColumn, { crossAxisAlignment: 'center', mainAxisSize: 'min', gap: "16px" },
                react_1.default.createElement(APFlex_1.APColumn, { mainAxisSize: 'min', crossAxisAlignment: 'center', gap: "2px", onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                        var currentDate, err_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, showDatePickerDialog({
                                            label: "From Date",
                                            initial: selected.from,
                                            clearable: clearable
                                        })];
                                case 1:
                                    currentDate = _a.sent();
                                    setSelected({ from: currentDate, to: selected.to });
                                    return [3 /*break*/, 3];
                                case 2:
                                    err_1 = _a.sent();
                                    if (err_1 instanceof Error)
                                        showErrorDialog_1.showErrorDialog(err_1.message);
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); } },
                    react_1.default.createElement(APText_1.APText, { variant: 'subtext', style: { fontSize: "12px" } }, "From"),
                    react_1.default.createElement(APText_1.APText, { variant: selected.from ? undefined : 'subtext' }, selected.from ? moment_2.default(selected.from).format("DD-MMM-YYYY") : "N/A")),
                react_1.default.createElement(SwapVertRounded_1.default, { fontSize: 'small', htmlColor: "#888" }),
                react_1.default.createElement(APFlex_1.APColumn, { mainAxisSize: 'min', crossAxisAlignment: 'center', gap: "2px", onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                        var currentDate, err_2;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, showDatePickerDialog({
                                            label: "To Date",
                                            initial: selected.to,
                                            clearable: clearable
                                        })];
                                case 1:
                                    currentDate = _a.sent();
                                    setSelected({ from: selected.from, to: currentDate });
                                    return [3 /*break*/, 3];
                                case 2:
                                    err_2 = _a.sent();
                                    if (err_2 instanceof Error)
                                        showErrorDialog_1.showErrorDialog(err_2.message);
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); } },
                    react_1.default.createElement(APText_1.APText, { variant: 'subtext', style: { fontSize: "12px" } }, "To"),
                    react_1.default.createElement(APText_1.APText, { variant: selected.to ? undefined : 'subtext' }, selected.to ? moment_2.default(selected.to).format("DD-MMM-YYYY") : "N/A")))));
}
exports.APFilterDate = APFilterDate;
